<template>
  <element>
    <nav-breadcrumb panel v-if="action != 'View' " :menu="[{label: '贷款业务 '}, {label: '贷款审核'}, {label: '审核'}]"/>
    <nav-breadcrumb panel v-if="action == 'View' " :menu="[{label: '贷款业务 '}, {label: '贷款审核'}, {label: '查看'}]"/>

    <el-row>
      <el-col class="grid-content bg-purple">
        <form-build
          :form-data="financingDetail"
          :form-rules="financingRules"
          :form-columns="financingColumns"
          class="formTable"
        />
        <panel label="房屋信息">
            <panel :label="'抵押物'+(idx+1)"  v-for="(item, idx) in financingDetail.properties" :key="idx" >
                <!--<form-build
                    :form-data="item"
                    :form-rules="financingRules"
                    :form-columns="houseColumns"
                    class="formTable"
                />-->
                <el-form :model="item"  ref="Form" label-width="150px" class="formTable">
                    <el-row :gutter="10" class="bg-purple xamhtrpg">
                        <el-col :span="12">
                            <el-form-item label="权属：" >
                                {{item.pr__propertyOwner}}
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="位置：" >
                                {{item.pr__propertyLocation}}
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="用途：" >
                                {{item.pr__propertyUsage}}
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="面积：" >
                                {{item.pr__propertyArea}}㎡
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="产权证号：" >
                                {{item.pr__propertyCertNo}}
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="土地证：" >
                                {{item.pr__propertyLandNo}}
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="土地使用权面积：" >
                                {{item.pr__propertyLandArea}}㎡
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="债权最高本金余额：">
                                {{Math.floor((item.asm__nominalTotalValue-item.asm__pledgeRightsAmount)/10000)*10000|formatMoney(0)}}元
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="暂作价：" >
                                {{Math.floor((item.asm__nominalTotalValue)/10000)*10000|formatMoney(0)}}元
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="担保合同编号：">
                               {{item.doc__warrantNo}}
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="抵押期限：">
                                {{item.doc__pledgeFr}}至 {{item.doc__pledgeTo}}
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="备注：">
                                {{item.doc__remarks}}
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </panel>
            <!--<el-form  :model="financingDetail"  ref="Form" label-width="150px">
                <el-row :gutter="10" class="bg-purple xamhtrpg">
                    <el-col :span="24">
                        <el-form-item label="备注：" style="width: 60%">
                            {{financingDetail.fi__remarks}}
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>-->
        </panel>
        <panel v-for="(item, idx) in financingDetail.coborrowers.filter(item=>item.co__borrowerICFront)" :key="idx">
          <el-checkbox true-label="true" false-label="false" :label="'共借人'+(idx+1)" v-model="item.co__checked" disabled></el-checkbox>
          <panel class="zhengjianxinxi"  v-if="item.co__checked">
          <form-build
            :form-data.sync="item"
            :form-rules="coRules"
            :form-columns="coColumns"
            class="formTable"

          />
          </panel>
          <panel class="zhengjianxinxi"  v-if="item.co__checked">
          <photo-browser v-model="item.co__borrowerICFront" type='image' label="本人身份证正面"/>
          <photo-browser v-model="item.co__borrowerICBack" type='image' label="本人身份证反面"/>
              <div class="zhenjianyyzz zhenjianyyzz2"><file-upload  v-model="item.co__borrowerHukou1" :editable="false" ></file-upload>户口本</div>
          </panel>
        </panel>
        <panel title="他项权证">
          <photo-browser v-model="financingDetail.fidoc__hisWarrant" type='image' label=""/>
        </panel>
        <panel title="附件列表">
          <files-data-table :files="financingDetail.files"></files-data-table>
        </panel>
          <panel label="">
              <el-row>
                  <el-col class="grid-content bg-purple">
                      <el-tabs v-model="tabName">
                          <template>
                              <el-tab-pane label="审核记录" name="tabName1">
                                  <data-table :table-data="approveTableData" :columns="approveTableColumns" :is-pagination-show="false"></data-table>
                              </el-tab-pane>
                              <el-tab-pane label="流程图" name="tabName2">
                                  <img
                                      src="../../assets/images/FQQY.png"  style="width: 100%"></img>
                              </el-tab-pane>
                          </template>
                      </el-tabs>
                  </el-col>
              </el-row>
          </panel>
        <panel v-if="action != 'View' ">
          <form-build
            :form-data.sync="approveDetail"
            :form-rules="financingRules"
            :form-columns="approveColumns"
            class="formTable"
          />
        </panel>

      </el-col>
    </el-row>
    <div class="xzmt tr" v-if="action != 'View' ">
        <el-button type="primary" @click="onSubmit('Approved')">审核通过</el-button>
        <el-button @click="onSubmit('Rejected')">否决</el-button>
    </div>
      <div class="xzmt tr" v-if="action == 'View' ">
          <el-button @click="$router.back()">返回</el-button>
      </div>
    <el-dialog :visible.sync="dialogVisible" title="客户详情"  width="70%">
      <customer-view :application-id="financingDetail.fi__referenceId" ></customer-view>
    </el-dialog>
  </element>
</template>

<script>
  import xhr from '../../utils/xhr'
  import Status2CN from "../../filters/Status2CN";
  import moment from 'moment'
  import {formatMoney} from "../../filters/CommonFilters";
  import CustomerView from "../dealer/CustomerView";
  export default {
    name: "FinancingAdd",
    components: {CustomerView},
    data(){

      return {
          tabName:'tabName1',
        dialogVisible:false,
        unit2:'',
        unit:'',
        coRules:{

        },
        coColumns:[
          {
            label: '与借款人关系',
            field: 'co__relationship',
          },
          {
            label: '姓名',
            field: 'co__borrowerName',
          },
          {
            label: '身份证号码',
            field: 'co__borrowerIC',
          },
          {
            label: '手机号',
            field: 'co__borrowerContactNo',
          },
          {
            label: '住所地址',
            field: 'co__borrowerAddress',
            span:24
          },
        ],
        approveDetail:{},
        transactionId: this.$route.query['transactionId']||'',
        financingDetail :{
          coborrowers:[],
            approvals:[]
        },
        financingRules:{},

        customerOption:[],
        productOptions:[],
        approveColumns:[

          {
            label: '审核意见',
            field: 'a__remarks',
            component: 'el-input',
            type: 'textarea',
            span:24
          },

        ],
        approveTableColumns: [
            {
                label: '节点',
                field: 'a__nodeName',
                formatter: (r,c,v)=> {
                    return Status2CN(v)
                }
            },
          {
            label: '日期',
            field: 'a__approverDate'
          },
          {
            label: '审核人员',
            field: 'a__approverName'
          },
          {
            label: '审核结果',
            field: 'a__approvingStatus',
            formatter: (r,d,v)=> {
              return Status2CN(v)
            }
          },
            {
                label: '审核备注',
                field: 'a__remarks'
            },

        ],
        houseColumns:[
          {
            label: '权属',
            field: 'pr__propertyOwner',

          },
          {
            label: '位置',
            field: 'pr__propertyLocation',

          },
          {
            label: '用途',
            field: 'pr__propertyUsage',

          },
          {
            label: '面积',
            field: 'pr__propertyArea',
            unit:'㎡'
          },
          {
            label: '产权证号',
            field: 'pr__propertyCertNo',

          },
          {
            label: '土地证',
            field: 'pr__propertyLandNo',

          },
        ],
      }
    },
    computed:{
      action() {
        return this.$route.query.action||'Approve'
      },
      approveTableData() {

          let dataApprove = { count: 0,
              data: []}
          let count = 0
          count++
          dataApprove.data =  [
                  {
                      a__nodeName:'项目申请人',
                      a__approverDate: moment((this.financingDetail.fi__createdDate||{})).format('YYYY-MM-DD HH:mm:ss'),
                      a__approverName: this.financingDetail.createdBy__userName,
                      a__approvingStatus: '提交成功',
                  }
              ]
          this.financingDetail.approvals.forEach(item=>{
              if(item.a__approvingDate){
                  dataApprove.data.push(
                      {
                          a__nodeName:item.a__nodeName,
                          a__approverDate: moment((item.a__approvingDate||{})).format('YYYY-MM-DD HH:mm:ss'),
                          a__approverName: item.a__approverName,
                          a__approvingStatus: item.a__approvingStatus,
                          a__remarks: item.a__remarks,
                      }
                  )
                  count++
              }

          })
          dataApprove.count = count
          return dataApprove
      },
      financingColumns(){
        return [
          {
            label: '贷款编号',
            field: 'fi__transactionNo',

          },
          {
            label: '贷款状态',
            field: 'fi__transactionStatus',
            formatter: function (c,v) {
               return v=='Pending Approval'?'待审核':Status2CN('Financing_'+v)
            }
          },
          {
            label: '客户姓名',
            field: 'fi__customerName',
            component: (r,v)=> {
              const showDialog = this.showDialog
              return {
                template: `<div>${v}&nbsp;&nbsp;&nbsp;&nbsp;<el-button type="primary" size="mini"  @click="showDialog">业务审查表</el-button></div>`,
                methods: {
                  showDialog
                }
              }
            }
          },
          {
            label: '客户手机号',
            field: 'ba__customerContactNo',

          },
          {
            label: '渠道商',
            field: 'd__dealerName',
            span:24
          },
          {
            label: '贷款金额',
            field: 'fi__totalAmount',
            formatter: function (c,v) {
              return formatMoney(v)
            },
            unit:'元',
          },
          {
            label: '贷款产品',
            field: 'p__productName',

          },
          {
            label: '申请日期',
            field: 'fi__transactionDate',
            formatter: function (c,v) {
              if(v){
                return moment(v).format('YYYY-MM-DD')
              }else{
                return ''
              }

            },
            span:12
          },
          {
            label: '是否调整期限',
            field: 'fi__endDateFixed',
            component: 'el-checkbox',
            props: {
              'true-label':'Y',
              'false-label':'N'
            },
            disabled: true

          },
          {
            label: '开始日期',
            field: 'fi__startDate',
            formatter: function (c,v) {
              if(v){
                return moment(v).format('YYYY-MM-DD')
              }else{
                return ''
              }

            }

          },
          {
            label: '结束日期',
            field: 'fi__endDate',
            formatter: function (c,v) {
              if(v){
                return moment(v).format('YYYY-MM-DD')
              }else{
                return ''
              }

            }
          },

          /*{
            label: '服务费',
            field: 'fi__lendingFee',
            formatter: function (c,v) {
              if(v){
                return v
              }else{
                return 0
              }

            }
          },*/

          {
            label: '贷款合同利率',
            field: 'fi__interestRate',
            unit:this.unit

          },
          {
            label: '留存收益率',
            field: 'dfi__interestRate',
            unit:this.unit2

          },
          {
            label: '罚息复利率',
            field: 'fi__penaltyInterestRate',
            unit:'%（年利率）',
            span:24
          },
          {
            label: '还款方式',
            field: 'fi__repaymentFormula',
            formatter: function (c,v) {
              return Status2CN(v)
            }
          },
          {
            label: '还款期数（月）',
            field: 'fi__repaymentCount',
          },

          {
            label: '贷款用途',
            field: 'fi__intendedUse',
            span:24
          },
          {
            label: '还款码',
            field: 'fi__repaymentCode',
          },
          {
            label: '收款账号',
            field: 'cb__accountNo',
          },
          {
            label: '户名',
            field: 'cb__accountName',
          },
          {
            label: '开户行',
            field: 'cb__bank',
          },
          {
            label: '代理人',
            field: 'fi__proxyPersonName',
              formatter: function (c,v) {
                  return v+c.fi__proxyPersonContactNo
              },
            span:24
          },
            {
                label: '放款账户',
                field: 'fi__payAccountId',
                formatter: function (c,v) {
                    return c.pba__accountName +'-'+ c.pba__branch+'-'+ c.pba__accountNo
                },
                span:24
            },
        ]
      },
      fileList: {
        get() {
          return this.financingDetail.files
        },
        set(newVal) {
          this.financingDetail.files = newVal.map(item => Object.assign(item, {
              'pa__fileId': item.fileId,
              'pa__checked': true
            })
          )
        }
      },
     /* unit() {
        let unit
        let interestType = (this.productOptions.filter(item=>item.value== this.financingDetail.p__productId)[0]||{}).dp__interestType
        if(interestType=='Yearly'){
          unit="%（年利率）"
        }
        if(interestType=='Daily'){
          unit="%（日利率）"
        }
        if(interestType=='Monthly'){
          unit="%（月利率）"
        }

        return unit
      }*/
    },
    watch:{
      'financingDetail.p__productId':function (newVal) {
        let lendingFee = (this.productOptions.filter(item=>item.value== newVal)[0]||{}).dp__lendingFee
        let interestRate = (this.productOptions.filter(item => item.value == newVal)[0]||{}).dp__interestRate
        let lendingFeeType = (this.productOptions.filter(item=>item.value== newVal)[0]||{}).dp__lendingFeeType
        let interestType = (this.productOptions.filter(item=>item.value== newVal)[0]||{}).dp__interestType

        if(lendingFeeType=='Rate'){
          if(this.financingDetail.fi__totalAmount){
            this.financingDetail.fi__lendingFee = this.financingDetail.fi__totalAmount*interestRate/100
          }
        }else{
          this.financingDetail.fi__lendingFee = lendingFee
        }
        this.financingDetail.fi__interestType = interestType

      },
      'financingDetail.fi__totalAmount':function (newVal) {
        if(this.financingDetail.p__productId) {
          let lendingFee = (this.productOptions.filter(item => item.value == this.financingDetail.p__productId)[0]||{}).dp__lendingFee
          let interestRate = (this.productOptions.filter(item => item.value == this.financingDetail.p__productId)[0]||{}).dp__interestRate
          let lendingFeeType = (this.productOptions.filter(item => item.value == this.financingDetail.p__productId)[0]||{}).dp__lendingFeeType
          let interestType  = (this.productOptions.filter(item => item.value == this.financingDetail.p__productId)[0]||{}).dp__interestType
/*          console.log(lendingFee)
          console.log(lendingFeeType)
          console.log(interestType)*/
          if (lendingFeeType == 'Rate') {
            if (this.financingDetail.fi__totalAmount) {
              this.financingDetail.fi__lendingFee = this.financingDetail.fi__totalAmount * interestRate / 100
            }
          } else {
            this.financingDetail.fi__lendingFee = lendingFee
          }
          this.financingDetail.fi__interestType = interestType
        }
      }
    },
    mounted() {
      this.data()
      this.getFinanceProductFangList()
    },
    methods:{
        Status2CN,
      showDialog:function(){
        window.open('/ix/fang/financing/ReviewForm.jasper?applicationId='+this.financingDetail.fi__referenceId)
      },
      data : function () {
        xhr.getFinancingFang({
          'fi.transactionId': this.$route.query['transactionId']
        }, res=>{
          try{
            if(res.data.status == 'success') {

              this.financingDetail = res.data.data
              console.log(this.financingDetail)
              if( this.financingDetail.ba__dealerId) {
                this.getFinanceProductFangList()
              }
              let interestType =  this.financingDetail.fi__interestType

              if(interestType=='Yearly'){
                this.unit="%（年利率）"
              }
              if(interestType=='Daily'){
                this.unit="%（日利率）"
              }
              if(interestType=='Monthly') {
                this.unit = "%（月利率）"
              }
              if(this.financingDetail.dfi__interestType=='Yearly'){
                this.unit2="%（年利率）"
              }
              if(this.financingDetail.dfi__interestType=='Daily'){
                this.unit2="%（日利率）"
              }
              if(this.financingDetail.dfi__interestType=='Monthly'){
                this.unit2="%（月利率）"
              }
              this.financingDetail.properties.forEach(item=>{
                  item.pr__propertyOwner =""
                  item.pr__owners.forEach(itemP=>{
                      item.pr__propertyOwner = item.pr__propertyOwner+","+itemP.ow__ownerName
                  })
                  item.pr__propertyOwner = item.pr__propertyOwner.substr(1);
              })
            }
          }catch(e){}
        })

      },
      getFinanceProductFangList: function () {
        xhr.getFinanceProductFangList(
          Object.assign({
            'd.dealerId':this.financingDetail.ba__dealerId
          }, {}, {}),
          res=> {
            try {
              this.productOptions = []
              this.productOptions = res.data.data.map(item=>{
                return {
                  label: item.p__productName,
                  value:item.p__productId,
                  'dp__interestRate':item.dp__interestRate,
                  'dp__interestType':item.dp__interestType,
                  'p__productName':item.p__productName,
                }

              })
              this.financingColumns[13].options = this.productOptions||[]
              //console.log( this.productOptions  )
            }catch(e){

            }
          })

      },
      onSubmit :function (status) {
        this.approveDetail.fi__transactionId = this.transactionId
        this.approveDetail.a__approvingStatus = status
        xhr.updateApproveFinancing(
          this.approveDetail,
          res=> {
            try{
              if(res.data.status == 'success') {
                this.$router.push({
                  path: 'List'
                })
              }else{

               /* this.$message.error(res.data.msgs[0].text)*/
              }

            }catch (e) {

              this.$message.error(error.msgs[0].text)

            }
          }
        )
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/dealer/ApproveFinancing.vue